<template>
  <div>
    <el-form ref="form" :rules="rules" :model="form" label-width="150px">
      <div class="integra-title">
        {{ $t('message.title.emailSetting') }}
      </div>
      <!-- <el-form-item label="邮箱服务器:" prop="hostname"> -->
      <el-form-item :label="$t('message.title.emailHost')" prop="hostname">
        <el-input v-model="form.hostname"></el-input>
      </el-form-item>
      <!-- <el-form-item label="端口号:" prop="email"> -->
      <el-form-item :label="$t('message.title.emailPost')" prop="post">
        <el-input type="number" v-model="form.post"></el-input>
      </el-form-item>
      <!-- <el-form-item label="邮箱账号:" prop="email"> -->
      <el-form-item :label="$t('message.title.emailUser')" prop="email">
        <el-input v-model="form.email"></el-input>
      </el-form-item>
      <!-- <el-form-item label="邮箱密码:" prop="password"> -->
      <el-form-item :label="$t('message.title.emailPassWord')" prop="password">
        <el-input v-model="form.password" :type="passw"></el-input>
      </el-form-item>

      <div style="display: flex;margin-top: 68px">
        <el-button style="margin-left: auto;" type="success" size="mini" @click="onSubmit('form')">{{
          $t("message.button.save")
        }}</el-button>
        <el-button type="warning" size="mini" @click="textLink">{{ $t("message.button.testLink") }}
        </el-button>
      </div>

    </el-form>
  </div>
</template>

<style scoped>
.title-heading p {
  font-size: 18px;
  font-weight: 400;
  margin: 0;
}

.notifications {
  width: 100%;
  height: 800px;
  background: #fff;
  overflow: hidden;
}

.integra-title {
  font-size: 14px;
  font-weight: 600;
  padding-left: 25px;
  padding-bottom: 10px;
  margin: 10px 0;
  border-bottom: 1px solid #DCDFE6;
  flex: 1
}
</style>

<script>
import axios from "axios";
export default {
  data() {
    return {
      editable: false,
      old_form: {},
      passw: "password",
      form: {
        hostname: '',
        name: '',
        password: '',
      },
      rules: {
        hostname: {
          required: true, message: this.$t("message.error.emailHost"), trigger: 'blur'
        },
        email: [
          { required: true, message: this.$t("message.error.emailAccounts"), trigger: 'blur' },
          { type: 'email', message: this.$t("message.error.emailAddress"), trigger: ['blur', 'change'] }
        ],
        password: {
          required: true, message: this.$t("message.error.emailPassWord"), trigger: 'blur'
        },
        post: {
          required: true, message: this.$t("message.error.post"), trigger: 'blur'
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    textLink() {
      console.log(this.form);
      const formVal = {};
      formVal.host = this.form.hostname;
      formVal.mailAddress = this.form.email;
      formVal.mailPassword = this.form.password;
      formVal.post = this.form.post + "";
      console.log(formVal);
      axios.post('/pmdm/mail/testSendMailConnection', formVal).then(res => {
        if (res.data.code === 200) {
          this.$message({
            message: response.data.message,
            type: 'success'
          });
        }

      })
        .catch(function (error) {
          this.$message({
            message: res.data.message,
            type: 'error'
          });
        });
    },

    cancel() {
      this.form = this.deepClone(this.old_form);
      // this.$router.push("/notifications");
    },
    getNotifications() {
      var vm = this;
      axios.get('/pmdm/admin/getMailSettings')
        .then(function (response) {
          if (response.data.code == 200) {
            vm.form = response.data.object;
            vm.old_form = vm.deepClone(vm.form);
          };
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    onSubmit(form) {
      var vm = this;

      this.$refs[form].validate((valid) => {
        if (valid) {
          var formVal = this.form;
          axios.post('/pmdm/admin/saveMailSettings', formVal)
            .then(function (response) {
              console.log(response);
              vm.$message({
                message: response.data.message,
                type: 'success'
              });
              vm.editable = false;
              this.old_form = this.deepClone(this.form);
            })
            .catch(function (error) {
              vm.getNotifications();
            });
        } else {
          vm.$message.error(this.$t('message.error.save'));
          return false;
        }
      });

    },
  },
  created() {
    this.getNotifications();
  }
};
</script>